<script>
import { mapGetters } from 'vuex'
import service from '../../../../domain/usuarios/services'

export default {
  name: 'PrimeiroAcessoDefineSenha',
  data () {
    return {
      senha: '',
      confirmaSenha: '',
      showForm: false,
      success: false,
      loading: false,
      intervalId: null,
      timer: 3,
      primeiroLogin: false
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    senhasDiferentes () {
      return this.senha !== this.confirmaSenha
    },
    isValid () {
      return this.senha.length && this.confirmaSenha.length && !this.senhasDiferentes
    },
    precisaDefinirSenha () {
      return JSON.parse(localStorage.getItem('primeiroAcesso')) || this.primeiroLogin
    }
  },
  created () {
    this.load()
  },
  mounted () {
    this.$nextTick(() => {
      this.showForm = true
      if (!this.precisaDefinirSenha) this.startTimer(this.callbackVoltar)
    })
  },
  methods: {
    load () {
      service.find(this.currentUser.id)
      .then(response => {
        this.primeiroLogin = response.data.primeiroLogin
      })
    },
    submit () {
      if (this.senhasDiferentes) return alert('As senhas estão diferentes')
      if (!this.isValid) return alert('Senha inválida. Tente outra')
      this.loading = true

      service.alterarSenha({ password: this.senha }, this.currentUser.id)
        .then(response => {
          this.success = true
          this.startTimer(this.callbackDefineSenha)
        })
        .finally(() => {
          this.loading = false
        })
    },
    callbackVoltar () {
      this.$router.back()
    },
    callbackDefineSenha () {
      service.updatePrimeiroLogin(this.currentUser.id)
      .then(response => {
        localStorage.setItem('primeiroAcesso', false)
        if (JSON.parse(localStorage.getItem('somenteConsultaReboque'))) {
          this.$router.push({name: 'config.consulta-reboque'})
        } else {
          this.$router.replace({name: 'dashboard.main'})
        }
      })
    },
    startTimer (callback = () => {}) {
      this.intervalId = setInterval(() => {
        if (this.timer < 1) {
          clearInterval(this.intervalId)
          return callback()
        }
        --this.timer
      }, 1000)
    }
  }
}
</script>

<template>
  <div class="primeiro-acesso-container">
    <transition name="slide-up">
      <div class="primeiro-acesso-form center-flex" v-if="showForm">
        <div v-if="!precisaDefinirSenha">
          <div class="success text-center">
            <span><i class="fa fa-lock"></i></span>
            <br>
            <span class="text-2x">Sua senha já foi redefinida</span>
            <br>
            <button class="btn btn-default m-t" @click="callbackVoltar">Voltar ({{ timer }})</button>
          </div>
        </div>
        <div v-else>
          <transition name="slide-up">
            <div class="success text-center" v-if="success">
              <span><i class="fa fa-check-circle text-success"></i></span>
              <br>
              <span class="text-2x">Senha alterada!</span>
              <br>
              <button class="btn btn-default m-t" @click="callbackDefineSenha">Fechar ({{ timer }})</button>
            </div>
          </transition>
          <div v-if="loading">
            <div class="loader"></div>
          </div>
          <div v-if="!loading && !success">
            <div class="m-b-lg primeiro-acesso-header">
              <img src="~assets/logo_min.png" alt="Logo" height="100" />
              <h4 class="m-b">Olá, esse é o seu primeiro acesso ao sistema. Por favor, defina sua senha de acesso</h4>
            </div>
            <div class="form-group">
              <label for="" class="control-label">Senha: </label>
              <input autofocus type="password" class="form-control" v-model="senha">
            </div>
            <div class="form-group">
              <label for="" class="control-label">Confirme a senha: </label>
              <input type="password" class="form-control" v-model="confirmaSenha">
            </div>
            <div class="form-group m-t-lg">
              <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs" :disabled="!isValid">Cadastrar</u-button>
              <u-button class="btn m-b-xs w-xs m-r-xs btn-link"
                @click="$router.push({ name: 'logout', query: { redirect: '/dashboard' } })">Logout</u-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.primeiro-acesso-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, .7);
  z-index: 2000;
}

.primeiro-acesso-form {
  position: relative;
  z-index: 2000;
  background-color: white;
  width: 500px;
  height: 500px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.45);
  padding: 20px;
}

.success i {
  font-size: 100px;
}

.primeiro-acesso-header {
  text-align: center;
}

.center-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  background-image: url('../../../../assets/svg/loader1.svg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  width: 100px;
  height: 100px;
  animation: rotate 1s infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(720deg);
  }
}

.primeiro-acesso-form div.form-group {
  padding: 0px 50px;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s;
}

.slide-up-enter-to {
  transform: translateY(-1%);
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(10%);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// PrimeiroAcessoDefineSenha.vue?3b564211